import { InMemoryCache } from '@apollo/client';

export const createApolloCache = () => new InMemoryCache();
